import { lazy, ComponentType } from 'react';

const RELOAD_KEY = 'chunk-reload-ts';
const RELOAD_COOLDOWN = 10000;

function lazyWithRetry<T extends ComponentType<unknown>>(
  importFn: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      return await importFn();
    } catch (error) {
      const lastReload = Number(sessionStorage.getItem(RELOAD_KEY) || '0');
      const now = Date.now();

      if (now - lastReload > RELOAD_COOLDOWN) {
        sessionStorage.setItem(RELOAD_KEY, String(now));
        window.location.reload();
        return new Promise(() => {});
      }

      throw error;
    }
  });
}

export default lazyWithRetry;
